import React, { useEffect, useState } from "react";
import Address from "./Address";
import DetailsWindow from "../containers/DetailsWindow";
import NewAddress from "./NewAddress";
import {
  GetShippingAddress,
  ShippingAddressDelete,
} from "../../server/ShippingAddress";
import { useDispatch, useSelector } from "react-redux";
import { setToggleCart } from "../../server/CartsOpen";
import { allPolygon } from "../../server/Polygon";
import * as actionType from "../../store/action";
import { UpdateUser } from "../../server/Customer";

const AddressShipping = ({ setSelectedAddres, parent }) => {
  const [newAddress, setNewAddress] = useState(false);
  const [address, setAddress] = useState([]);
  const [polygonState, setPolygonState] = useState([]);

  const dispatch = useDispatch();
  const { user, role, stationId } = useSelector((state) => ({
    user: state.user.user,
    role: state.user.role,
    stationId: state.user.stationId,
  }));
  const mapUserToAddress = (userData) => {
    if (!userData || !userData.addrStreet) return [];

    const singleAddress = {
      MainAddress: 1,
      userId: userData.id,
      streetName: userData.addrStreet,
      houseNumber: userData.addrHouse,
      apartment: userData.addrApartment,
      zipCode: userData.addrZipCode,
      name: userData.lastName,
    };
    return [singleAddress];
  };

  useEffect(() => {
    if (address && address.length > 0) {
      const element = address[0];
      if (setSelectedAddres) {
        setSelectedAddres(element);
      }
    }
  }, [address]);
  useEffect(() => {
    const fetchAddressAndPolygon = async () => {
      try {
        if (role) {
          dispatch(setToggleCart(false));
        }
        if (user) {
          const shippingAddress = mapUserToAddress(user);
          setAddress(shippingAddress);
          const response = await allPolygon();
          const polygons = response.data.map((item) => item.polygon).flat();
          setPolygonState(polygons);
        }
        if (parent === "reset") {
          setNewAddress(true);
        }
      } catch (error) {
        console.error("Error occurred:", error);
      }
    };
    dispatch({
      type: actionType.UPDATE_STATION_ID,
      payload: stationId,
    });

    fetchAddressAndPolygon();
  }, [user, role, parent, stationId]);

  useEffect(() => {
    if (address.length && polygonState.length) {
      const element = address.find((x) => x.MainAddress);
      if (element) {
        if (setSelectedAddres) {
          setSelectedAddres(element);
        }
      }
    }
  }, [address, polygonState]);

  const pushAddress = async (newAddressData) => {
    const updatedProfile = {
      ...user,
      addrStreet: newAddressData.streetName,
      addrHouse: Number(newAddressData.houseNumber),
      addrApartment: Number(newAddressData.apartment),
      addrZipCode: newAddressData.zipCode,
      lastName: newAddressData.name,
    };

    try {
      await UpdateUser(user.id, updatedProfile);
      dispatch({
        type: "UPDATE_USER",
        payload: updatedProfile,
      });
      setNewAddress(false);
    } catch (error) {
      console.error("❌ כשל בעדכון הכתובת החדשה:", error);
    }
  };
  const setActiveAddress = (element) => {
    const addressList = [...address];
    addressList.forEach((item) => (item.MainAddress = 0));
    addressList.find((x) => x.Id === element.Id).MainAddress = 1;
    setAddress(addressList);
  };

  return (
    <div className="private-area">
      {parent !== "reset" ? (
        <section id="address">
          <DetailsWindow title="כתובת למשלוח">
            {address && address.length > 0 ? (
              <Address
                address={address}
                setActiveAddress={setActiveAddress}
                setNewAddress={() => setNewAddress(true)}
              />
            ) : (
              <button
                onClick={() => setNewAddress(true)}
                className="add-new-address-placeholder"
              >
                + הוספת כתובת
              </button>
            )}
          </DetailsWindow>
        </section>
      ) : null}
      <section id="add-address">
        {newAddress && polygonState && polygonState.length ? (
          <DetailsWindow title="הוספת כתובת">
            <NewAddress
              pushAddress={pushAddress}
              address={address}
              polygonState={polygonState}
              oldStationId={stationId}
              setNewAddress={setNewAddress}
            />
          </DetailsWindow>
        ) : null}
      </section>
    </div>
  );
};
export default AddressShipping;
